 angular.module('qkr').filter('lookupBeneficiary', [function() {

        return function(lookupBeneficiaries, searchText) {
            if (lookupBeneficiaries) {
                return lookupBeneficiaries.filter(lookupBeneficiary => {
                    if (searchText) {
                        lookupBeneficiary.filterKey =
                            lookupBeneficiary.lastName +
                            lookupBeneficiary.firstName +
                            lookupBeneficiary.year +
                            lookupBeneficiary.referenceNumber;

                        return lookupBeneficiary.filterKey.indexOf(searchText) !== -1;
                    } else {
                        return true;
                    }
                });
            }
        };
    }]);



// WEBPACK FOOTER //
// ./src/filters/lookup_beneficiary.js